import React from 'react';

import './PageLoading.css';
import Loader from '../Loader/Loader';

function PageLoading() {
  return (
    <div className="PageLoading">
      <Loader />
    </div>
  );
}

export default PageLoading;